import AdmissionPA from "../views/AdmissionPA.vue";
import RenseignementsGeneraux from "../components/AdmissionPA/RenseignementsGeneraux.vue";
import AutorisationDePratique from "../components/AdmissionPA/AutorisationDePratique.vue";
import DeclarationsObligatoires from "../components/AdmissionPA/DeclarationsObligatoires.vue";
import AttestationVeracite from "../components/AdmissionPA/AttestationVeracite.vue";
import InformationsComplementaires from "../components/AdmissionPA/InformationsComplementaires.vue";
import Formations from "../components/AdmissionPA/Formations.vue";
import AutresAutorisationsDePratique from "../components/AdmissionPA/AutresAutorisationsDePratique.vue";
import Langues from "../components/AdmissionPA/Langues.vue";

const routeName = "AdmissionPA";

export default [
  {
    path: "/admission-pa",
    component: AdmissionPA,
    meta: {
      title: "Admission PA | OTSTCFQ",
    },
    props: {
      routeName: routeName,
    },
    children: [
      {
        path: "renseignements-generaux",
        name: `${routeName}/RenseignementsGeneraux`,
        component: RenseignementsGeneraux,
      },
      {
        path: "langues",
        name: `${routeName}/Langues`,
        component: Langues,
      },
      {
        path: "formations",
        name: `${routeName}/Formations`,
        component: Formations,
      },
      {
        path: "declarations-obligatoires",
        name: `${routeName}/DeclarationsObligatoires`,
        component: DeclarationsObligatoires,
      },
      {
        path: "attestation-veracite",
        name: `${routeName}/AttestationVeracite`,
        component: AttestationVeracite,
      },
      {
        path: "autres-autorisations-de-pratique",
        name: `${routeName}/AutresAutorisationsDePratique`,
        component: AutresAutorisationsDePratique,
      },
      {
        path: "autorisation-de-pratique",
        name: `${routeName}/AutorisationDePratique`,
        component: AutorisationDePratique,
      },
      {
        path: "informations-complementaires",
        name: `${routeName}/InformationsComplementaires`,
        component: InformationsComplementaires,
      },
    ],
  },
];
